import ListNotification from "./view/ListNotifications";
import CreateNotification from "./view/CreateNotification";
import EditNotification from "./view/EditNotification";
import ViewNotification from "./view/ViewNotification";

const NotificationsPage = {
  ListNotification,
  CreateNotification,
  EditNotification,
  ViewNotification,
};

export default NotificationsPage;
